import { useEffect, useState } from "react";
import HolidayRuleLineItem from "./HolidayRuleLineItem";
import { HolidayRule } from "../../../../models/HolidayRule";
import { HolidaySchedule } from "../../../../models/HolidaySchedule";
import EmptyStateView from "../../../../components/EmptyStateView";
import CreateHolidayRuleButton from "../../../../components/CreateHolidayRuleButton/CreateHolidayRuleButton";
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHead,
} from "../../../../design/table";
import moment from "moment";
import { Select } from "../../../../design/select";
import { Heading } from "../../../../design/heading";
import { Field, Label } from "../../../../design/fieldset";

interface HolidayRulesEditorProps {
  holidaySchedule: HolidaySchedule;
}

export const HolidayRulesEditor: React.FC<HolidayRulesEditorProps> = ({
  holidaySchedule,
}) => {
  const [year, setYear] = useState(Number(moment().format("YYYY")));
  const [editedRules, setEditedRules] = useState<HolidayRule[]>(
    holidaySchedule?.holidayRules || [],
  );

  useEffect(() => {
    setEditedRules(holidaySchedule.holidayRules);
  }, [holidaySchedule]);

  const next10Years = Array.from(
    { length: 10 },
    (_, i) => Number(moment().format("YYYY")) + i,
  );

  const sortedRules = editedRules.sort(
    (a, b) =>
      moment(a.date || a.holiday?.dates?.[0]).valueOf() -
      moment(b.date || b.holiday?.dates?.[0]).valueOf(),
  );
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <Heading>Holiday Rules</Heading>
        <Field className="flex flex-wrap items-center gap-4 sm:flex-nowrap">
          <Label>Year:</Label>
          <Select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
          >
            {next10Years.map((yr) => (
              <option key={yr} value={yr}>
                {yr}
              </option>
            ))}
          </Select>
          <CreateHolidayRuleButton
            className="whitespace-nowrap shrink-0"
            holidayScheduleId={holidaySchedule._id}
          />
        </Field>
      </div>

      {sortedRules.length > 0 ? (
        <div className="overflow-hidden border rounded-lg">
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader>Holiday</TableHeader>
                <TableHeader>Start</TableHeader>
                <TableHeader>End</TableHeader>
                <TableHeader>Duration</TableHeader>
                <TableHeader>Parent</TableHeader>
                <TableHeader />
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRules.map((rule) => (
                <HolidayRuleLineItem key={rule._id} value={rule} year={year} />
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <EmptyStateView
          title="No Holiday Rules"
          message="There are no holiday rules for this schedule yet."
          action={
            <CreateHolidayRuleButton holidayScheduleId={holidaySchedule._id} />
          }
        />
      )}
    </div>
  );
};
